import { useSelector } from 'react-redux';
import {
  // isMobileBrowser,
  getRealBalanceObj,
  calculateUsableBonus,
  isSmartPhone
} from '../../../utilities/helper';

import React from 'react';

import ContestConfirmModalMWeb from './index_mWeb';
import ContestConfirmModalWeb from './index_web';
interface Props {
  visible: boolean;
  onPressDismiss?: any;
  entryFee?: number;
  joinContest?: any;
  bonusPercentage?: number;
  selectedTeamCount?: number;
}
const ContestConfirmModal = ({
  visible,
  onPressDismiss,
  entryFee = 0,
  joinContest,
  selectedTeamCount = 1,
  bonusPercentage = 0
}: Props) => {
  const { balanceInfo = {} } = useSelector((state: any) => state.user);
  const balanceObj = getRealBalanceObj(balanceInfo);
  // const bottomSheetWidth = isMobileBrowser ? 'root_mobile' : 'root';
  // const className = `${bottomSheetWidth}`;

  const usableBonusAmount: any = calculateUsableBonus(
    entryFee * selectedTeamCount,
    bonusPercentage,
    balanceObj['bonusBalance']
  );

  const usableBalance =
    balanceObj['primaryBalance'] +
    balanceObj['cashbackBalance'] +
    balanceObj['gameBalance'] +
    usableBonusAmount;

  const totalEntryFee = selectedTeamCount * entryFee;
  if (isSmartPhone) {
    return (
      <ContestConfirmModalMWeb
        visible={visible}
        onPressDismiss={onPressDismiss}
        entryFee={entryFee}
        selectedTeamCount={selectedTeamCount}
        joinContest={joinContest}
        bonusPercentage={bonusPercentage}
        balanceObj={balanceObj}
        usableBonusAmount={usableBonusAmount}
        totalEntryFee={totalEntryFee}
        usableBalance={usableBalance}
      />
    );
  } else {
    return (
      <ContestConfirmModalWeb
        visible={visible}
        onPressDismiss={onPressDismiss}
        entryFee={entryFee}
        selectedTeamCount={selectedTeamCount}
        joinContest={joinContest}
        bonusPercentage={bonusPercentage}
        balanceObj={balanceObj}
        usableBonusAmount={usableBonusAmount}
        totalEntryFee={totalEntryFee}
        usableBalance={usableBalance}
      />
    );
  }
};
export default React.memo(ContestConfirmModal);
